module.exports = __webpack_public_path__ + "img/4terGeburtstag.ef86c6a7.jpg";